import { render } from "./TemporaryLogin.vue?vue&type=template&id=24b7a9ff"
import script from "./TemporaryLogin.vue?vue&type=script&lang=js"
export * from "./TemporaryLogin.vue?vue&type=script&lang=js"

import "./TemporaryLogin.vue?vue&type=style&index=0&id=24b7a9ff&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__